import { profileConstants, globalConstants } from "../../constants";

const initialState = {
  profileData:{},
  profileImgUrl: null,
  openModal: false,
};

const profileReducer = (state = initialState, action) => {
  switch (action.type) {
    case profileConstants.GET_PROFILE_IMAGE_URL + globalConstants.SUCCESS:
      return {
        ...state,
        profileImgUrl: action.data,
      };
    case profileConstants.GET_PROFILE_DATA:
      return {
        ...state,
        profileData: action.data,
      };
    default:
      return state;
  }
};

export default profileReducer;
